import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {},
  label: {
    color: theme.palette.accent?.main,
    textTransform: 'none',
    // ...theme.typography.subtitle2,
    fontSize: 14,
    '& .MuiButton-startIcon, & .MuiButton-label-text, & .MuiButton-endIcon': {
      opacity: ({ loading }: { loading: boolean }) => (loading ? '0' : '1'),
    },
    '& .MuiButton-startIcon': {
      marginRight: 10,
    },
    [theme.breakpoints.down('sm')]: {
      '& .MuiButton-startIcon': {
        margin: '0',
      },
    },
  },
  outlined: {
    padding: 15,
    height: 48,
    border: 'none',
    backgroundColor: '#FFFFFF',
    color: '#333',
    '&.MuiButton-outlinedSecondary': {
      borderColor: theme.palette.accent?.main,
      color: theme.palette.text.primary,
    },
    '&:hover': {
      // borderColor: theme.palette.button.hover,
      backgroundColor: '#fff',
      color: '#6366F1',
    },
    '&:hover $label': {
      color: theme.palette.button?.hover,
    },
    '&:active': {
      borderColor: theme.palette.button?.active,
      backgroundColor: 'transparent',
    },
    '&:active $label': {
      color: theme.palette.button?.active,
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 48,
    },
  },
  contained: {
    padding: 18,
    height: 48,
    '& $label': {
      color: theme.palette.common?.white,
    },
    boxShadow: 'none',
    backgroundColor: theme.palette.button?.default,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#E0E7FF',
      '& .MuiButton-label': {
        color: '#6366F1',
      },
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: theme.palette.button?.active,
    },
    // '&:disabled': {
    //   boxShadow: 'none',
    //   backgroundColor: theme.palette.button.active,
    // },
    // '&:disabled $label': {
    //   color: theme.palette.text.secondary,
    // },
  },
  text: {
    padding: '15px 16px',
    fontFamily: 'SBSansText-Regular',
    fontWeight: 500,
    height: 48,
    '& $label': {
      color: '#333333',
    },
    boxShadow: 'none',
    backgroundColor: '#F1F5F9',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#E0E7FF',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: theme.palette.button?.active,
    },
    '& .MuiButton-startIcon': {
      marginRight: 12,
    },
    '&:disabled': {
      '& .MuiButton-label': {
        color: '#fff',
      },
      '&.MuiButton-root': {
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
      },
    },
  },

  containedSizeLarge: {
    padding: '17px 27px',
  },
}));
